import React, { Component, useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player";
/// Link
import { Link } from "react-router-dom";

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

//CSS
import "./sideBar.css";
/// Menu
import MetisMenu from "metismenujs";

// all with language and everything

import { useContext } from "react";
import { LanguageContext } from "../../../resources/languageContext";
import d from "../../../resources/dictionary.json";
import Cookies from "js-cookie";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
    //this.mm("dispose");
    this.mm.dispose();
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const VideoPlayer = ({ videoList }) => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [played, setPlayed] = useState(false);
  const playerRef = useRef(null);

  const handleVideoEnd = () => {
    setPlayed(false);
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videoList.length);
  };

  const handlePlay = () => {
    if (!played) {
      setPlayed(true);
    }
  };

  const handleError = () => {
    console.log(
      `Error playing video: ${videoList[currentVideoIndex]}. Trying next.`
    );
    handleVideoEnd();
  };

  return (
    <div className="video-wrapper">
      <ReactPlayer
        loop
        ref={playerRef}
        url={videoList[currentVideoIndex]}
        playing
        autoPlay
        muted
        width="100%"
        height="100%"
        onEnded={handleVideoEnd}
        onPlay={handlePlay}
        onError={handleError}
        className="video-banner"
      />
      <a
        className="clickable-overlay"
        href="https://labosalem.dz/"
        target="_blank"
      ></a>
    </div>
  );
};

class SideBar extends Component {
  /// model box
  state = {
    // initial state
    show: false,
    calendarCollapse: false,
  };

  handleCalendarToggle = () => {
    return this.setState((prevState) => ({
      calendarCollapse: !prevState.calendarCollapse,
    }));
  };

  /// Open menu
  componentDidMount() {
    // sidebar open/close
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }

    btn.addEventListener("click", toggleFunc);
  }
  render() {
    /// Path
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    //my own paths
    let dashboard = ["", "dashboard"];
    let patients = ["patients"];
    let prescriptions = ["prescriptions"];
    let settings = ["account"];
    let about = ["about"];
    let contact = ["contact-us"];

    return (
      <div className="dlabnav">
        <PerfectScrollbar className="dlabnav-scroll">
          <MM className="metismenu" id="menu">
            <li className={`${dashboard.includes(path) ? "mm-active" : ""}`}>
              <Link to="" className="ai-icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5723 1.01787C13.0594 1.06684 12.4611 1.26882 11.9909 1.55649C11.5757 1.80744 2.2886 10.1499 1.86119 10.6518C1.71465 10.8231 1.50705 11.1475 1.39103 11.374C0.981937 12.2003 0.988043 12.0473 1.00636 18.3393L1.02468 24.0009L1.18343 24.411C1.63527 25.5739 2.44736 26.3879 3.60748 26.8409L4.01658 27H13.9387H23.8608L24.2882 26.8653C25.4361 26.4981 26.3459 25.6167 26.8161 24.411L26.9748 24.0009L26.9932 18.3393C27.0115 12.035 27.0237 12.2064 26.6024 11.3618C26.4803 11.1292 26.2421 10.7803 26.0712 10.5844C25.7292 10.2111 16.8329 2.15631 16.3383 1.77683C15.5812 1.18925 14.6042 0.926064 13.5723 1.01787ZM14.6775 3.07441C15.0378 3.1907 14.9462 3.11113 20.2278 7.88523C24.0012 11.2883 24.679 11.931 24.8378 12.2186L25.0209 12.5553V18.1251V23.6949L24.8744 23.9703C24.679 24.3436 24.3493 24.6803 23.9829 24.8761L23.6776 25.0414L21.4368 25.0598L19.1898 25.0781V21.2344C19.1898 16.956 19.1898 16.9805 18.7746 16.1359C18.4449 15.4626 17.7488 14.771 17.0527 14.4282C16.2589 14.0426 15.9414 13.9936 13.9998 13.9936C12.0581 13.9936 11.7406 14.0426 10.9468 14.4282C10.2507 14.771 9.55465 15.4626 9.22493 16.1359C8.80972 16.9805 8.80972 16.956 8.80972 21.2344V25.0781L6.56885 25.0598L4.32187 25.0414L4.01047 24.8761C3.83951 24.7843 3.57695 24.5762 3.4243 24.4048C2.91751 23.8417 2.94194 24.1784 2.96025 18.0027L2.97857 12.5553L3.16175 12.2186C3.3205 11.931 4.0349 11.2577 8.10144 7.58532C10.8491 5.10646 12.974 3.23967 13.1266 3.1601C13.6029 2.92139 14.0975 2.89691 14.6775 3.07441ZM16.149 16.1542C16.5276 16.3378 16.8512 16.6622 17.0649 17.0662L17.2054 17.3294L17.2237 21.1976L17.242 25.072H13.9998H10.7636V21.32C10.7636 18.9575 10.788 17.4885 10.8247 17.3477C10.9102 17.0478 11.2277 16.5827 11.5085 16.3623C11.9787 15.9828 12.1924 15.9522 14.0913 15.9706L15.801 15.9828L16.149 16.1542Z"
                    fill="#112361"
                  />
                </svg>
                <span className="nav-text fs-20">{this.props.dashboard}</span>
              </Link>
            </li>
            <li className={`${patients.includes(path) ? "mm-active" : ""}`}>
              <Link to="patients" className="ai-icon">
                <svg
                  width="23"
                  height="26"
                  viewBox="0 0 23 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.3801 0.902555C7.57468 1.34552 5.44187 3.5549 5.10281 6.36037C4.77468 9.0674 6.49187 13.0213 8.72859 14.7057C10.3255 15.9088 11.9059 15.9854 13.5028 14.9463C15.488 13.6557 17.1887 10.5604 17.4676 7.73302C17.7794 4.61584 15.838 1.83771 12.7755 1.02287C12.4419 0.929898 12.152 0.902555 11.4466 0.891617C10.9489 0.88068 10.4731 0.886148 10.3801 0.902555Z"
                    fill="#112361"
                  />
                  <path
                    d="M6.3877 14.7385C6.01036 14.7877 5.06973 15.0447 4.6377 15.2197C2.67989 16.0127 1.10489 17.6533 0.404891 19.6385C0.0986411 20.5135 -0.0052651 21.126 0.000203648 22.1377C0.000203648 22.8869 0.0166099 23.1111 0.115047 23.4666C0.508797 24.9158 1.4877 25.6322 3.45098 25.9221C4.14005 26.026 18.4244 26.026 19.1135 25.9221C21.0822 25.6322 22.0557 24.9158 22.4494 23.4666C22.619 22.8432 22.619 21.465 22.4494 20.6775C22.1268 19.19 21.4705 17.9486 20.4479 16.915C19.6877 16.1439 18.933 15.6354 17.976 15.2416C17.4838 15.0393 16.576 14.7932 16.0947 14.7275L15.8486 14.7002L15.7502 14.9682C15.701 15.1158 15.5533 15.3893 15.4275 15.5752C15.1213 16.0346 14.0986 17.09 13.2291 17.8447C12.3869 18.5666 11.3479 19.4033 11.2822 19.4033C11.2549 19.4033 10.894 19.1299 10.4783 18.7963C8.36739 17.09 7.09317 15.7666 6.81427 14.9682C6.75411 14.7986 6.68848 14.7057 6.6338 14.7057C6.59005 14.7111 6.48067 14.7275 6.3877 14.7385ZM17.6479 19.4361C17.6643 19.4854 17.6807 19.8025 17.6807 20.1471V20.7705H18.3041C18.6486 20.7705 18.9658 20.7869 19.015 20.8033C19.1463 20.8525 19.1463 22.2744 19.015 22.3236C18.9658 22.34 18.6486 22.3564 18.3041 22.3564H17.6807V22.9963C17.6807 23.3518 17.6588 23.6744 17.6369 23.7127C17.5986 23.7619 17.4072 23.7783 16.8549 23.7674L16.1221 23.751L16.1057 23.051L16.0893 22.3564H15.4111C14.7932 22.3564 14.7275 22.3455 14.6729 22.2525C14.6455 22.1924 14.6182 21.8807 14.6182 21.5635C14.6182 21.2463 14.6455 20.9346 14.6729 20.8744C14.7275 20.7814 14.7932 20.7705 15.4111 20.7705H16.0947V20.0979C16.0947 19.726 16.1111 19.4033 16.133 19.3869C16.1494 19.365 16.494 19.3486 16.8932 19.3486C17.5002 19.3486 17.6205 19.3596 17.6479 19.4361Z"
                    fill="#112361"
                  />
                </svg>
                <span className="nav-text ">{this.props.patients}</span>
              </Link>
            </li>
            <li
              className={`${prescriptions.includes(path) ? "mm-active" : ""}`}
            >
              <Link to="prescriptions" className="ai-icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_8_260)">
                    <path
                      d="M7.19141 0.0655384C6.92344 0.158508 6.68828 0.36632 6.56797 0.617882C6.46953 0.814758 6.45313 0.956945 6.45313 1.48741V2.11632L5.58906 2.14913C4.39141 2.19835 3.77344 2.34054 2.93672 2.7671C1.55859 3.4671 0.56875 4.71944 0.147656 6.31085L0.0273438 6.75382V15.0663V23.3788L0.153125 23.8655C0.284375 24.396 0.650781 25.2109 0.929688 25.621C1.18125 25.9819 1.77188 26.5999 2.14375 26.8898C2.84375 27.4257 3.82266 27.8304 4.70859 27.9452C5.03125 27.989 7.91328 27.9999 14.3008 27.989L23.4336 27.9726L23.8547 27.8523C24.8336 27.5733 25.5609 27.1796 26.2008 26.589C27.1523 25.703 27.7047 24.7077 27.918 23.4827C28.0438 22.7663 28.0438 7.36085 27.918 6.64444C27.7211 5.52882 27.2234 4.58273 26.3867 3.74601C25.2383 2.59757 24.0078 2.1382 22.0609 2.13273H21.5578L21.5414 1.42726C21.5195 0.743664 21.5141 0.710852 21.3555 0.486633C20.8797 -0.186024 19.8898 -0.131336 19.5125 0.596008C19.3703 0.863976 19.3594 0.93507 19.3594 1.50929V2.13273H14H8.64063V1.50929C8.64063 0.93507 8.62969 0.863976 8.4875 0.596008C8.24141 0.120226 7.68359 -0.103992 7.19141 0.0655384ZM6.45313 5.49601C6.45313 6.75382 6.48047 6.92882 6.74297 7.20773C7.30078 7.80929 8.36719 7.56866 8.58594 6.7921C8.61328 6.68272 8.64063 6.08116 8.64063 5.45226V4.32023H14H19.3594V5.45226C19.3594 6.08116 19.3867 6.68272 19.4141 6.7921C19.6328 7.56866 20.6992 7.80929 21.257 7.20773C21.5195 6.92882 21.5469 6.75382 21.5469 5.49054V4.30382L22.3289 4.33663C22.7609 4.35304 23.2477 4.40773 23.4281 4.45695C24.2977 4.6921 25.0797 5.34288 25.4844 6.16319C25.7195 6.65538 25.8125 7.12569 25.8125 7.91319V8.58585H14H2.1875V7.91319C2.1875 7.12569 2.28047 6.65538 2.51563 6.16319C2.99688 5.18976 3.89922 4.53898 5.00391 4.37491C5.15156 4.35304 5.53984 4.33116 5.86797 4.3257L6.45313 4.32023V5.49601ZM25.8125 16.8601C25.8125 22.7773 25.807 22.9632 25.7031 23.3788C25.4297 24.4398 24.6148 25.3093 23.5648 25.6538L23.1602 25.7851H14H4.83984L4.43516 25.6538C3.94844 25.4952 3.31953 25.0851 3.00781 24.7296C2.67969 24.3632 2.42266 23.871 2.29688 23.3788C2.19297 22.9632 2.1875 22.7718 2.1875 16.8601V10.7733H14H25.8125V16.8601Z"
                      fill="#112361"
                    />
                    <path
                      d="M6.04297 14.1038C5.67109 14.2678 5.35938 14.7218 5.35938 15.0936C5.35938 15.4655 5.67109 15.9194 6.04297 16.0835C6.23438 16.171 6.42031 16.1874 7.53594 16.1874C8.94141 16.1874 9.06172 16.1655 9.39531 15.8428C9.50469 15.7335 9.60859 15.5585 9.65781 15.3835C9.73438 15.121 9.73438 15.0663 9.65781 14.8038C9.60859 14.6288 9.50469 14.4538 9.39531 14.3444C9.06172 14.0218 8.94141 13.9999 7.53594 13.9999C6.42031 13.9999 6.23438 14.0163 6.04297 14.1038Z"
                      fill="#112361"
                    />
                    <path
                      d="M12.4247 14.1421C11.7903 14.4538 11.6372 15.2577 12.102 15.7882C12.4302 16.16 12.5505 16.1874 13.9997 16.1874C15.4216 16.1874 15.5583 16.16 15.881 15.8155C16.3622 15.3014 16.1708 14.41 15.5036 14.1038C15.3122 14.0163 15.1317 13.9999 13.9942 13.9999C12.72 13.9999 12.7091 13.9999 12.4247 14.1421Z"
                      fill="#112361"
                    />
                    <path
                      d="M18.9763 14.0874C18.0685 14.4811 18.0739 15.7225 18.9872 16.0999C19.1513 16.171 19.4357 16.1874 20.4638 16.1874C21.5794 16.1874 21.7653 16.171 21.9568 16.0835C22.3286 15.9194 22.6403 15.4655 22.6403 15.0936C22.6403 14.7218 22.3286 14.2678 21.9568 14.1038C21.7653 14.0163 21.5794 13.9999 20.4528 14.0053C19.4247 14.0053 19.1294 14.0218 18.9763 14.0874Z"
                      fill="#112361"
                    />
                    <path
                      d="M5.97158 20.5952C5.3372 20.9069 5.18408 21.7108 5.64892 22.2413C5.97158 22.6132 6.10283 22.6405 7.53564 22.6405C8.56377 22.6405 8.84814 22.6241 9.0122 22.553C9.75595 22.2468 9.94189 21.3116 9.36767 20.7702C9.06142 20.4749 8.91923 20.453 7.53017 20.453C6.26689 20.453 6.25048 20.453 5.97158 20.5952Z"
                      fill="#112361"
                    />
                    <path
                      d="M12.5508 20.5241C12.1625 20.6772 11.9164 20.9725 11.8399 21.3882C11.7578 21.8202 12.0531 22.3397 12.4961 22.5366C12.6875 22.6241 12.8735 22.6405 14 22.6405C15.4547 22.6405 15.586 22.6077 15.9031 22.2303C16.357 21.678 16.1602 20.8632 15.5039 20.5569C15.3125 20.4694 15.1375 20.4585 14 20.4585C13.1524 20.4585 12.6602 20.4858 12.5508 20.5241Z"
                      fill="#112361"
                    />
                    <path
                      d="M18.9763 20.5405C18.0685 20.9343 18.0739 22.1757 18.9872 22.553C19.1513 22.6241 19.4357 22.6405 20.4638 22.6405C21.8966 22.6405 22.0278 22.6132 22.3505 22.2413C22.8208 21.7053 22.6568 20.9069 22.0169 20.5897C21.7489 20.4585 21.7161 20.453 20.4583 20.453C19.4302 20.4585 19.1294 20.4749 18.9763 20.5405Z"
                      fill="#112361"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_8_260">
                      <rect width="28" height="28" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span className="nav-text">{this.props.prescriptions}</span>
              </Link>
            </li>
            <li className={`${settings.includes(path) ? "mm-active" : ""}`}>
              <Link to="account" className="ai-icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_38_286)">
                    <path
                      d="M11.1944 0.0601501C10.5162 0.224213 9.87638 0.792963 9.65217 1.42734C9.60295 1.55312 9.49904 2.07812 9.41154 2.59765C9.19826 3.85546 9.00685 4.2164 8.37795 4.52265C8.12638 4.64296 8.0006 4.67031 7.68342 4.67031C7.34982 4.66484 7.19123 4.62109 6.39826 4.31484C5.50138 3.97031 5.49592 3.97031 4.9217 3.96484C4.39123 3.96484 4.32013 3.97577 3.99201 4.13437C3.79513 4.22734 3.52717 4.41327 3.39045 4.55546C3.1006 4.85077 0.694353 8.96875 0.530291 9.46093C0.388103 9.87656 0.426385 10.5383 0.612322 10.9484C0.814666 11.375 1.01154 11.5937 1.7881 12.2281C2.17092 12.5453 2.54279 12.8789 2.61388 12.9609C3.0842 13.557 3.09513 14.4266 2.63029 15.0172C2.57013 15.0937 2.19279 15.4273 1.79357 15.7609C1.0006 16.4117 0.825603 16.6086 0.617791 17.0516C0.426385 17.4617 0.388103 18.1234 0.524822 18.5391C0.584978 18.7031 1.19201 19.8187 1.88654 21.0164C3.25373 23.3898 3.39045 23.5758 3.99201 23.8656C4.32013 24.0242 4.39123 24.0352 4.9217 24.0352C5.49592 24.0297 5.50138 24.0297 6.39826 23.6852C7.19123 23.3789 7.34982 23.3352 7.68342 23.3297C8.32326 23.3242 8.83732 23.6469 9.1381 24.2375C9.2092 24.3742 9.3131 24.8281 9.41154 25.4023C9.58654 26.4578 9.65763 26.693 9.89279 27.0375C10.1225 27.3711 10.4123 27.6062 10.8279 27.8031L11.1834 27.9727L13.8303 27.9891C15.5037 28 16.5756 27.9836 16.7451 27.9508C17.4069 27.8086 17.9373 27.393 18.2381 26.7805C18.3912 26.4578 18.4569 26.2117 18.5881 25.4242C18.7631 24.3523 18.8834 24.0352 19.2279 23.7344C19.5561 23.45 19.8733 23.3297 20.3162 23.3352C20.6553 23.3352 20.8084 23.3789 21.6014 23.6852C22.4983 24.0297 22.5037 24.0297 23.0779 24.0352C23.6084 24.0352 23.6795 24.0242 24.0076 23.8656C24.6037 23.5758 24.7459 23.3844 26.1022 21.0437C26.7803 19.8625 27.3819 18.7961 27.4365 18.6758C27.5076 18.5172 27.5295 18.3094 27.535 17.9102C27.535 17.4344 27.5186 17.325 27.3928 17.0625C27.1795 16.6195 26.999 16.4172 26.1897 15.75C25.4076 15.0992 25.2053 14.8531 25.074 14.4211C24.9701 14.0766 24.9701 13.9234 25.074 13.5789C25.2053 13.1414 25.4186 12.8844 26.1897 12.25C26.9881 11.5937 27.1795 11.3805 27.3928 10.9375C27.5186 10.675 27.535 10.5656 27.535 10.0898C27.5295 9.69062 27.5076 9.48281 27.4365 9.32421C27.3819 9.2039 26.7803 8.1375 26.1022 6.95625C24.7459 4.61562 24.6037 4.42421 24.0076 4.13437C23.6795 3.97577 23.6084 3.96484 23.0779 3.96484C22.5037 3.97031 22.4983 3.97031 21.6014 4.31484C20.8084 4.62109 20.6498 4.66484 20.3162 4.67031C19.6764 4.67578 19.1623 4.35312 18.8615 3.7625C18.7959 3.63124 18.6865 3.17187 18.5881 2.60859C18.5061 2.09453 18.3912 1.55859 18.3365 1.41093C18.1506 0.885931 17.6311 0.3664 17.0787 0.136713C16.8326 0.0328064 16.6631 0.027338 14.1092 0.0164013C12.6217 0.010931 11.3092 0.0328064 11.1944 0.0601501ZM16.2967 2.19843C16.2967 2.20937 16.3678 2.63593 16.4608 3.15546C16.6959 4.51171 16.9639 5.10234 17.6584 5.775C18.4295 6.52968 19.5506 6.94531 20.5623 6.86328C21.0928 6.81953 21.2404 6.78125 22.2467 6.41484C22.7061 6.24531 23.0889 6.11953 23.0944 6.13046C23.1053 6.1414 23.6248 7.03828 24.2483 8.11562C25.1506 9.68515 25.3639 10.0953 25.3092 10.1445C25.2709 10.1773 24.9592 10.4344 24.6256 10.7133C23.8381 11.3586 23.5209 11.7195 23.2475 12.2719C22.9412 12.8789 22.8428 13.3055 22.8428 14C22.8428 14.6945 22.9412 15.1211 23.2475 15.7281C23.5209 16.2805 23.8381 16.6414 24.6256 17.2867C24.9592 17.5656 25.2709 17.8227 25.3092 17.8555C25.3639 17.9047 25.1451 18.3203 24.2483 19.8844C23.6248 20.9617 23.1053 21.8586 23.0944 21.8695C23.0889 21.8805 22.7061 21.7547 22.2467 21.5852C21.2404 21.2187 21.0928 21.1805 20.5623 21.1367C19.5506 21.0547 18.424 21.4758 17.6529 22.2195C16.9694 22.8922 16.6904 23.4937 16.4608 24.8445C16.3678 25.3641 16.2967 25.7906 16.2967 25.7961C16.2967 25.807 15.2631 25.8125 13.9998 25.8125C12.7365 25.8125 11.7029 25.807 11.7029 25.7961C11.7029 25.7906 11.6319 25.3641 11.5389 24.8445C11.3092 23.4937 11.0412 22.9141 10.3522 22.2305C9.58654 21.4758 8.45451 21.0547 7.43732 21.1367C6.90685 21.1805 6.7592 21.2187 5.75295 21.5852C5.29357 21.7547 4.91076 21.8805 4.90529 21.8695C4.73576 21.6562 2.63576 17.9102 2.6631 17.8828C2.68498 17.8609 3.00217 17.5984 3.3631 17.2977C4.12873 16.6633 4.41857 16.3516 4.69201 15.8594C5.02013 15.2742 5.15138 14.7328 5.15138 14C5.15138 13.2672 5.02013 12.7258 4.69201 12.1406C4.41857 11.6484 4.12873 11.3367 3.3631 10.7023C3.00217 10.4016 2.68498 10.1391 2.6631 10.1172C2.63576 10.0898 4.73576 6.34375 4.90529 6.13046C4.91076 6.11953 5.29357 6.24531 5.75295 6.41484C6.88498 6.83046 6.99435 6.85234 7.65607 6.85781C8.33967 6.85781 8.76076 6.75937 9.37873 6.45312C9.87638 6.20703 10.2537 5.91718 10.6201 5.48515C11.1178 4.89453 11.3529 4.3039 11.5389 3.17187C11.599 2.79453 11.6647 2.42265 11.6811 2.33515L11.7139 2.18749H14.0053C15.2631 2.18749 16.2967 2.19296 16.2967 2.19843Z"
                      fill="#112361"
                    />
                    <path
                      d="M13.316 8.64614C12.5504 8.74458 11.6535 9.08911 10.9426 9.55942C10.5434 9.82192 9.81602 10.5547 9.54258 10.9649C8.2957 12.8571 8.2957 15.143 9.54258 17.0352C9.81602 17.4454 10.5434 18.1782 10.9426 18.4407C13.0262 19.8133 15.5801 19.693 17.4559 18.1344C19.102 16.7727 19.791 14.4649 19.1566 12.4414C18.5496 10.4946 16.9527 9.06176 14.9949 8.69536C14.5465 8.61333 13.7371 8.58598 13.316 8.64614ZM14.9566 10.943C15.9137 11.2383 16.7559 12.086 17.073 13.0704C17.2316 13.568 17.2316 14.4321 17.073 14.9297C16.7504 15.925 15.9246 16.7508 14.9293 17.068C14.4262 17.2321 13.6168 17.2321 13.0973 17.0735C12.0855 16.7618 11.2488 15.936 10.9262 14.9297C10.7676 14.4321 10.7676 13.568 10.9316 13.0704C11.309 11.8836 12.4027 10.9649 13.6168 10.8118C13.9395 10.768 14.6121 10.8336 14.9566 10.943Z"
                      fill="#112361"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_38_286">
                      <rect width="28" height="28" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span className="nav-text">{this.props.settings}</span>
              </Link>
            </li>
            <li className={`${about.includes(path) ? "mm-active" : ""}`}>
              <Link to="about" className="ai-icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.6604 0.0602913C9.39551 0.393885 6.42051 1.79935 4.1127 4.1017C-1.36699 9.57045 -1.36699 18.4298 4.1127 23.8986C6.33848 26.1134 9.03457 27.4369 12.2775 27.9017C12.9283 27.9947 15.0775 27.9892 15.7502 27.8962C21.2025 27.1415 25.5885 23.5212 27.2947 18.3642C27.7869 16.8712 27.9729 15.6954 27.9729 14.0001C27.9729 12.3048 27.7869 11.129 27.2947 9.63607C25.6104 4.5392 21.29 0.924353 15.9416 0.131384C15.2744 0.0329475 13.333 -0.0108032 12.6604 0.0602913ZM15.7775 2.32435C19.0916 2.83842 22.001 4.69779 23.8439 7.48139C26.0314 10.7736 26.4143 15.0009 24.8666 18.6158C23.2314 22.4275 19.8518 25.0415 15.7229 25.6869C14.908 25.8181 13.0596 25.8126 12.2557 25.6869C7.04941 24.8447 3.12285 20.9181 2.31348 15.7228C2.18223 14.897 2.18223 13.1033 2.31348 12.2775C2.83848 8.92513 4.65957 6.0431 7.43223 4.1892C9.08379 3.08451 10.8994 2.44467 13.0432 2.22045C13.4861 2.1767 15.2471 2.24232 15.7775 2.32435Z"
                    fill="#112361"
                  />
                  <path
                    d="M13.4805 7.52517C13.1633 7.63454 12.9008 7.87517 12.7148 8.20876C12.5727 8.46579 12.5508 8.55876 12.5508 8.91423C12.5563 9.40642 12.6656 9.65251 13.032 9.99158C13.7484 10.6478 14.8531 10.4345 15.3289 9.54314C15.4164 9.37908 15.4492 9.22595 15.4492 8.91423C15.4492 8.55876 15.4273 8.46579 15.2852 8.20876C15.1977 8.05017 15.0391 7.84783 14.9352 7.76033C14.5633 7.45408 13.9563 7.35564 13.4805 7.52517Z"
                    fill="#112361"
                  />
                  <path
                    d="M13.65 11.7852C13.382 11.8782 13.1414 12.1079 13.0102 12.3868C12.9172 12.5946 12.9062 12.8243 12.9062 16.3571V20.1087L13.032 20.3493C13.4203 21.0876 14.4211 21.1423 14.9023 20.4587L15.0664 20.2235L15.0828 16.4446C15.0992 12.2063 15.1156 12.3759 14.7109 12.0095C14.3883 11.7196 14.0383 11.6431 13.65 11.7852Z"
                    fill="#112361"
                  />
                </svg>
                <span className="nav-text">{this.props.about}</span>
              </Link>
            </li>

            <li className={`${contact.includes(path) ? "mm-active" : ""}`}>
              <Link to="contact-us" className="ai-icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.90626 2.98045C5.86251 2.99139 5.63829 3.02967 5.41407 3.06248C4.14532 3.27029 2.90391 3.92107 1.93594 4.88904C1.01173 5.81873 0.410163 6.91248 0.131256 8.20311C0.0328188 8.64061 0.02735 9.00154 0.02735 13.9726C0.02735 19.7148 0.0218813 19.5508 0.3336 20.5187C0.650788 21.4976 1.18126 22.3508 1.93594 23.1109C2.6961 23.8656 3.54923 24.3961 4.52813 24.7133C5.51798 25.0359 5.06954 25.0195 14.0274 25.0195C21.875 25.0195 22.307 25.014 22.75 24.9156C25.3859 24.3414 27.3711 22.3125 27.8961 19.6601C28.0109 19.0969 28.0109 8.90311 27.8961 8.33982C27.3766 5.72029 25.4899 3.75701 22.8594 3.10076C22.4 2.98592 22.3453 2.98592 14.1914 2.97498C9.6797 2.96951 5.95001 2.96951 5.90626 2.98045ZM22.4766 5.26092C23.368 5.52889 23.9859 5.88436 24.5274 6.4367C24.9156 6.81951 25.3258 7.44295 25.4844 7.86404C25.8016 8.70623 25.7852 8.38904 25.7852 14C25.7852 19.6109 25.8016 19.2937 25.4844 20.1359C25.1234 21.1039 24.057 22.1703 23.0891 22.5312C22.2305 22.8539 22.8922 22.832 14.2461 22.8484C5.7586 22.8648 5.86798 22.8703 5.08048 22.5914C3.97579 22.1976 2.90391 21.175 2.51563 20.1359C2.19844 19.2937 2.21485 19.6109 2.21485 14C2.21485 8.38904 2.19844 8.70623 2.51563 7.86404C2.89844 6.84686 3.95391 5.81873 5.02032 5.43045C5.80782 5.14061 5.50704 5.15154 14.1367 5.15701C21.4703 5.16795 22.2031 5.17889 22.4766 5.26092Z"
                    fill="#112361"
                  />
                  <path
                    d="M22.3943 9.89844C22.3068 9.93125 20.9889 10.9047 19.4685 12.0695C17.9482 13.2289 16.5646 14.2734 16.3896 14.3883C15.4107 15.0281 14.142 15.2359 12.9771 14.957C12.1295 14.7492 11.8123 14.5414 8.80449 12.2008C6.79746 10.6367 5.92792 9.99141 5.76933 9.94766C5.30449 9.82187 4.81777 10.0023 4.5498 10.407C4.35839 10.6914 4.34199 11.2437 4.51152 11.5281C4.62636 11.725 9.80527 15.7883 10.5381 16.2641C11.5225 16.8984 12.835 17.2812 14.0271 17.2812C15.3287 17.2812 16.8326 16.7945 17.8717 16.0398C17.9865 15.9523 19.3154 14.9406 20.8248 13.7867C22.6787 12.3703 23.6084 11.6266 23.6904 11.4898C23.7889 11.3367 23.8162 11.2109 23.8162 10.9375C23.8162 10.5164 23.674 10.243 23.3514 10.0297C23.1217 9.87656 22.6623 9.81641 22.3943 9.89844Z"
                    fill="#112361"
                  />
                </svg>
                <span className="nav-text">{this.props.contact}</span>
              </Link>
            </li>
          </MM>
        </PerfectScrollbar>
        <footer className="banners">
          <div className="bootstrap-carousel ">
            <VideoPlayer
              videoList={this.props.banner}
              className="video-banner"
            />
          </div>
        </footer>
      </div>
    );
  }
}

const SideBarfn = () => {
  const [banner, setBanner] = useState([]);
  const [activeImage, setActiveImage] = useState(1);
  const token = Cookies.get("jwt");
  const { language } = useContext(LanguageContext);

  let dashboard = d["dashboard"][language];
  let patients = d["patients"][language];
  let prescriptions = d["prescriptions"][language];
  let settings = d["settings"][language];
  let about = d["about"][language];
  let contact = d["contact us"][language];

  const getBanners = async () => {
    const request = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };
    try {
      let response = await fetch(
        "https://pharmacy.shls.care/api/pharmacy/banners",
        request,
        {
          mode: "cors",
        }
      );
      let data = await response.json();
      console.log(data);
      if (response.status === 200) {
        setBanner(data.image);
      } else if (response.status === 401) {
        console.log("401");
      } else {
        console.log("some other error");
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  useEffect(() => {
    let ignore = false;
    getBanners();
    return () => {
      window.scrollTo(0, 0);
      ignore = true;
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      let act = activeImage;
      if (activeImage === banner.length) {
        act = 1;
      } else {
        act += 1;
      }
      setActiveImage(act);
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  });

  return (
    <SideBar
      dashboard={dashboard}
      patients={patients}
      prescriptions={prescriptions}
      settings={settings}
      about={about}
      contact={contact}
      banner={banner}
      activeImage={activeImage}
    />
  );
};

export default SideBarfn;
